import React from "react";
import { useIntl } from "react-intl";
import { resolvePublicCatalogLink, } from "../utils/publicCatalogLink";
import css from "./PublicCatalogLink.module.css";
/**
 * "Zobrazit ve veřejném katalogu" next to a record's id (DB-801): opens the record in the public
 * catalog in a new tab. A record the catalog does not show gets a dimmed note instead; without a
 * configured public catalog nothing is rendered.
 */
export var PublicCatalogLink = function (_a) {
    var record = _a.record, notPublicMessageId = _a.notPublicMessageId;
    var formatMessage = useIntl().formatMessage;
    var state = resolvePublicCatalogLink(record);
    if (state.kind === "none") {
        return null;
    }
    if (state.kind === "not-public") {
        return (React.createElement("span", { className: css.notPublic }, formatMessage({ id: notPublicMessageId })));
    }
    return (React.createElement("a", { className: css.publicCatalogLink, href: state.url, target: "_blank", rel: "noopener noreferrer", title: formatMessage({ id: "ui-br-agency.publicCatalog.link.newTab" }) }, formatMessage({ id: "ui-br-agency.publicCatalog.link.label" })));
};
